import React from 'react';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Inline banner shown above a cost widget in Global View when the user's organizations span
 * more than one currency. Reusable across global cost widgets — see project_currency_uniformity.
 */
const MixedCurrencyBanner = () => {
  const { t } = useTranslation();
  return (
    <div
      className="d-flex align-items-start gap-2 px-3 py-2 mb-3 rounded"
      role="note"
      style={{
        backgroundColor: '#fff7ed',
        border: '1px solid #fdba74',
        color: '#9a3412',
        fontSize: '0.85rem',
      }}
    >
      <Info size={16} className="flex-shrink-0 mt-1" />
      <div>
        <strong className="d-block">
          {t(
            'shared.global_view_mixed_currency_title',
            'Per-organization breakdown'
          )}
        </strong>
        <span>
          {t(
            'shared.global_view_mixed_currency_body',
            'Totals are not summed because your organizations use different currencies. Each tile below shows the value in its native currency.'
          )}
        </span>
      </div>
    </div>
  );
};

export default MixedCurrencyBanner;
